import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

export const getAuditsTourSteps = (t: (key: string) => string): DriveStep[] => [
  {
    element: '[data-tour="audits-tabs"]',
    popover: {
      title: t("tour.audits.tabs.title"),
      description: t("tour.audits.tabs.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="audits-templates"]',
    popover: {
      title: t("tour.audits.templates.title"),
      description: t("tour.audits.templates.description"),
      side: "bottom",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const auditsTourConfig = {
  id: "audits" as const,
  steps: getAuditsTourSteps,
};
